import { useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { httpSetPassword } from '@/features/auth/http/auth.http'
import { MUTATION_KEYS } from '@/query-client'
import type { ErrorResponseData } from '@/types/commons.ts'

interface useResetPasswordProps {
	onSuccess?: () => void
	onError?: (error: AxiosError<ErrorResponseData>) => void
}

export const useSetPassword = (options?: useResetPasswordProps) => {
	return useMutation({
		mutationKey: [MUTATION_KEYS.SET_PASSWORD],
		mutationFn: (params: { token: string; password: string }) =>
			httpSetPassword(params),
		onError: (error: AxiosError<ErrorResponseData>) =>
			options?.onError?.(error),
		onSuccess: () => options?.onSuccess?.()
	})
}
